// 홈 데스크톱 썸네일 + 글리프 — 시안 C1 `.th` / `.help .hi` (신고 371 §8).
// 요청 사진이 있으면 서명 URL 첫 장, 없으면 신청 종류 글리프(이모지 금지 — 인라인 SVG).
import React, { useState } from 'react';
import { T, R } from '../../../theme';

// 차량 / 링크 / 스크린샷 / 직접 입력 — RequestCard 의 경로와 같은 24 그리드.
var PATHS = {
  car: 'M3 13l1.6-4.4A2 2 0 016.5 7h7.3a2 2 0 011.9 1.3L17 13M3 13h14v4H3v-4zm2.5 4v1.6M14.5 17v1.6',
  link: 'M10.3 13.7a3.8 3.8 0 005.7.4l2.6-2.6a3.8 3.8 0 00-5.4-5.4l-1.4 1.4M13.7 10.3a3.8 3.8 0 00-5.7-.4l-2.6 2.6a3.8 3.8 0 005.4 5.4l1.4-1.4',
  photo: 'M3 5h18v14H3V5zm1 12l4.6-4.2L13 17l3-2.6 4 3.4',
  pen: 'M4 20h4l10.5-10.5a2.1 2.1 0 00-3-3L5 17v3z'
};

/// 인라인 글리프 — props: { name, size }
export function Glyph(props) {
  var size = props.size || 16;
  var name = PATHS[props.name] ? props.name : 'car';
  return (<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d={PATHS[name]} />
    {name === 'car' ? <circle cx="18" cy="8.5" r="3.6" /> : null}
    {name === 'photo' ? <circle cx="8.6" cy="10" r="1.7" /> : null}
  </svg>);
}

export function kindOf(order) {
  if (order && order.car_model) return 'car';
  if (order && order.listing_url) return 'link';
  return 'photo';
}

function firstPhoto(order) {
  var list = (order && Array.isArray(order.request_photos)) ? order.request_photos : [];
  return (list[0] && list[0].url) || '';
}

/// props: { order, w, h, icon }
function Thumb(props) {
  var o = props.order || {};
  var w = props.w || 40;
  var h = props.h || w;
  var base = { width: w, height: h, borderRadius: R.md, flex: 'none', boxSizing: 'border-box', overflow: 'clip' };
  var src = firstPhoto(o);
  // 404·서명 만료 시 깨진 이미지 아이콘 대신 종류 글리프로 폴백 (V2 D3)
  var brokenSt = useState(false); var broken = brokenSt[0], setBroken = brokenSt[1];
  if (src && !broken) {
    return <img src={src} alt="" onError={function () { setBroken(true); }} style={Object.assign({}, base, { objectFit: 'cover', border: '1px solid ' + T.bd, display: 'block' })} />;
  }
  var kind = kindOf(o);
  var tone = o.status === 'completed'
    ? { background: T.warnTint, border: '1px solid ' + T.warnBd, color: T.warn }
    : kind === 'car'
      ? { background: T.head, border: '1px solid ' + T.bd, color: T.muted }
      : { background: T.accentTint, border: '1px solid ' + T.accentBd, color: T.accentPress };
  return (<span className="ss-th" style={Object.assign({}, base, tone, { display: 'grid', placeItems: 'center' })}>
    <Glyph name={kind} size={props.icon || 17} />
  </span>);
}

export default Thumb;
